export class PersonFilterModel {
    strFind: string = '';
    page: number = 1;
    take: number = 20;
    isClient: boolean;
    isShipping: boolean;
    isProvider: boolean;
    isSalesman: boolean;
    isStudent: boolean;
}